/** Cambio de clave movil: limpia la cache y vuelve al login con aviso.
 *
 * El backend cierra la sesion al cambiar la clave, asi que no se intenta
 * refrescar el perfil: se vacia la cache y se navega a `/m/login?passwordChanged=true`,
 * donde el aviso pide ingresar con la nueva contraseña (design.md §22.7).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authService, type ChangePasswordBody } from '@/services/authService';

export function useChangePasswordMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: ChangePasswordBody) => authService.changePassword(body),
    onSuccess: () => {
      queryClient.clear();
      window.location.href = '/m/login?passwordChanged=true';
    },
  });
}
